import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MainApiService from "../../../services/mainApi.service";
import { IGetCompanyGroups } from "../../../models/company-groups";
import { Table } from "@4uhub/lib4uhub";

const COMPANY_GROUP_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/CompanyGroup/";
const companyGroupService = new MainApiService<IGetCompanyGroups>(
  COMPANY_GROUP_ROUTE
);

const translationPath = "page.register.companyGroups.";

const CompanyGroupsPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const columns: GridColDef<IGetCompanyGroups>[] = [
    {
      field: "code",
      headerName: t(translationPath + "code") || "Code",
      maxWidth: 100,
    },
    {
      field: "name",
      headerName: t(translationPath + "name") || "Name",
    },
    {
      field: "filterRestrictionType",
      headerName:
        t(translationPath + "filter_restriction_type") ||
        "Filter Restriction Type",
      renderCell: (params) => params.value.value,
    },
  ];

  const handleRowClick = (params: GridRowParams<IGetCompanyGroups>) => {
    navigate(`${params.id.toString()}/edit`);
  };

  const handleAdd = () => {
    navigate("new");
  };

  return (
    <Table<IGetCompanyGroups>
      showDefaultMacroFilters={false}
      service={companyGroupService}
      columns={columns}
      title={t(translationPath + "company_groups")}
      searchInput
      onAdd={handleAdd}
      onRowClick={handleRowClick}
      searchInputPlaceHolder={
        t(translationPath + "search_company_groups") ||
        "Searh for a company group"
      }
      addButtonLabel={
        t(translationPath + "add_company_group") || "Add Company Group"
      }
      confirmOptions={{
        title: t(translationPath + "confirm.title"),
        description: t(translationPath + "confirm.description"),
        confirmationButtonProps: {
          variant: "contained",
        },
      }}
    />
  );
};

export default CompanyGroupsPage;
